<template>
  <div class="intro-ct">
    <div class="description-ct">
      <div>
        <p class="headline-paragraph">
          {{ $t('Gamification_Upsell_Introduction_Maximise_Player_Activity') }}
        </p>
      </div>
      <div>
        <p class="sub-paragraph">
          {{ $t('Gamification_Upsell_Introduction_Keep_Players_Active') }}
        </p>
      </div>
      <div>
        <el-button @click="$emit('scrollTo', 'letsPlaySection')" type="primary">
          {{ $t('Gamification_Upsell_Introduction_See_It_In_Action') }}
          <i class="el-icon-arrow-right el-icon-right" />
        </el-button>
      </div>
    </div>
    <div>
      <img
        src="@/img/gamification/xp-tb-gamification-hero.png"
        :alt="
          $t('Gamification_Upsell_Introduction_Image_Alt_Keep_Players_Active')
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationUpsellIntroduction'
}
</script>

<style scoped>
.intro-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 22px;
  padding: 60px 65px;
  background-color: #fff;
}

img {
  width: 534px;
  height: 400px;
  object-fit: contain;
}

.description-ct {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 500px;
}

.headline-paragraph {
  color: #176ca1;
  font-size: 32px;
  font-weight: 600;
  line-height: 42px;
}

.sub-paragraph {
  color: #7e8596;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-wrap: balance;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationUpsellIntroduction.vue